<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{ title }}</title>
    <g stroke-linecap="round" stroke-linejoin="round" stroke-width="2" fill="none" :stroke="stroke" stroke-miterlimit="10">
      <line x1="24" y1="25" x2="24" y2="38"></line>
      <line x1="17" y1="25" x2="17" y2="38"></line>
      <line x1="31" y1="25" x2="31" y2="38"></line>
      <polyline points="17 9 17 2 31 2 31 9"></polyline>
      <path d="M39,21V42a4,4,0,0,1-4,4H13a4,4,0,0,1-4-4V21"></path>
      <rect x="3" y="9" width="42" height="6"></rect>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Trash",
  props: {
    title: {
      default: 'Effacer',
      type: String,
    },
    stroke: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 14,
    },
  },
}
</script>
